import React, { useMemo } from 'react';
import clsx from 'clsx';
import Image from 'next/image';

import { BaseComponentProps } from '@utils/types/baseComponents';
import { AmenityV2Enum } from '@components/_shared/amenityV2/constants';
import { getAmenityV2Icon } from '@components/_shared/amenityV2/helpers';

import styles from './styles.module.scss';

type Props = {
  item:
    | Record<string, string>
    | Record<keyof typeof AmenityV2Enum, AmenityV2Enum>;
} & BaseComponentProps;

AmenityV2.defaultProps = {};

export default function AmenityV2(props: Props) {
  const { containerStyle, item } = props;

  const [key] = useMemo(() => Object.entries(item)[0], [item]);

  const amenity = useMemo(() => {
    return AmenityV2Enum[key as keyof typeof AmenityV2Enum];
  }, [key]);

  if (!amenity) return null;

  return (
    <div className={clsx([styles.amenity, containerStyle])}>
      <div className={styles.amenity__icon}>
        <Image src={getAmenityV2Icon(amenity)} alt={amenity} layout="fill" />
      </div>

      <div className={styles.amenity__title}>{amenity}</div>
    </div>
  );
}
